import config from '../../constants';
import { getOrganizationTaxIdValidationModel as buildOrganizationTaxIdValidationModel } from '../../constants/countries';

export const registerPaths = {
  firstName: 'adminFirstName',
  lastName: 'adminLastName',
  email: 'adminEmail',
  organizationName: 'name',
  organizationCountry: 'country',
  organizationLegalName: 'legalName',
  organizationTaxId: 'taxId',
  termsAndConditions: 'termsAndConditions'
};

export const registerValidationModels = {
  firstName: {
    required: true,
    maxLength: true,
    length: config.ACCOUNT_NAME_MAX_LENGTH,
    path: registerPaths.firstName
  },
  lastName: {
    required: true,
    maxLength: true,
    length: config.ACCOUNT_NAME_MAX_LENGTH,
    path: registerPaths.lastName
  },
  email: {
    required: true,
    email: true,
    maxLength: true,
    length: config.ACCOUNT_EMAIL_MAX_LENGTH,
    path: registerPaths.email
  },
  organizationName: {
    required: true,
    maxLength: true,
    length: config.ORGANIZATION_NAME_MAX_LENGTH,
    path: registerPaths.organizationName
  },
  organizationCountry: {
    required: true,
    path: registerPaths.organizationCountry
  },
  organizationLegalName: {
    required: true,
    maxLength: true,
    length: config.ORGANIZATION_LEGAL_NAME_MAX_LENGTH,
    path: registerPaths.organizationLegalName
  },
  organizationTaxId: {
    required: true,
    maxLength: true,
    length: config.ORGANIZATION_TAX_ID_MAX_LENGTH,
    path: registerPaths.organizationTaxId
  },
  termsAndConditions: {
    required: true,
    path: registerPaths.termsAndConditions
  }
};

// The tax ID format is country-specific (ABN, NZBN, EIN, BN, charity number),
// so its validation model is built from the currently-selected country rather
// than being static. The shared builder (constants/countries) produces the
// country-aware rules; here we add the register field `path` so this model can
// drive both the register form field and the save-button gate.
export const getOrganizationTaxIdValidationModel = (country) => ({
  ...buildOrganizationTaxIdValidationModel(country),
  path: registerPaths.organizationTaxId
});
